<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست پلن های VIP</h1>
          <div class="my-2">
            <b-row>
              <!-- Search -->
              <b-col cols="12" class="mb-1">
                <div
                  class="d-flex flex-column flex-md-row align-items-center justify-content-end"
                >
                  <b-form-group
                    class="d-inline-block w-100 mr-md-2"
                    label="جستجوی عنوان"
                    label-for="searchCommand"
                  >
                    <b-form-input
                      id="searchCommand"
                      v-model="getVipPlansDetails.title"
                      class="d-inline-block mr-1"
                      placeholder="پلن 6 ماهه"
                      @keydown.enter="setPageNumberAndGetPlansList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-100 mr-md-2"
                    label="جستجوی مدت زمان"
                    label-for="month"
                  >
                    <b-form-input
                      id="month"
                      v-model="getVipPlansDetails.month"
                      class="d-inline-block mr-1"
                      placeholder="6"
                      @keydown.enter="setPageNumberAndGetPlansList"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline-block w-100"
                    label="وضعیت پلن"
                    label-for="isActive"
                  >
                    <!-- isActive -->
                    <b-form-select
                      id="isActive"
                      v-model="getVipPlansDetails.isActive"
                      :options="isActiveOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-button
                    variant="primary"
                    @click="setPageNumberAndGetPlansList"
                    class="ml-1 mb-md-0"
                  >
                    اعمال
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-table
                  ref="refUserListTable"
                  class="position-relative"
                  :items="vipPlansList"
                  responsive
                  :fields="myTableColumns"
                  primary-key="id"
                  show-empty
                  bordered
                  striped
                  empty-text="موردی موجود نیست!"
                >
                  <template #cell(month)="data">
                    {{ data.item.month }} ماه
                  </template>
                  <template #cell(hasMidnightReserve)="data">
                    <b-badge
                      style="font-weight: normal !important"
                      :variant="
                        data.item.hasMidnightReserve ? 'success' : 'danger'
                      "
                    >
                      {{ data.item.hasMidnightReserve ? "دارد" : "ندارد" }}
                    </b-badge>
                  </template>
                  <template #cell(hasMasterReserve)="data">
                    <b-badge
                      style="font-weight: normal !important"
                      :variant="
                        data.item.hasMasterReserve ? 'success' : 'danger'
                      "
                    >
                      {{ data.item.hasMasterReserve ? "دارد" : "ندارد" }}
                    </b-badge>
                  </template>
                  <template #cell(hasFridayReserve)="data">
                    <b-badge
                      style="font-weight: normal !important"
                      :variant="
                        data.item.hasFridayReserve ? 'success' : 'danger'
                      "
                    >
                      {{ data.item.hasFridayReserve ? "دارد" : "ندارد" }}
                    </b-badge>
                  </template>
                  <template #cell(isActive)="data">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <b-badge
                        style="font-weight: normal !important"
                        :variant="data.item.isActive ? 'success' : 'danger'"
                      >
                        {{ data.item.isActive ? "فعال" : "غیر فعال" }}
                      </b-badge>
                    </div>
                  </template>
                  <template #cell(actions)="data">
                    <div class="d-flex align-items-center">
                      <b-link
                        :to="`/apps/vip/plans/${data.item.id}`"
                        class="mr-2"
                      >
                        <feather-icon
                          class="text-primary"
                          icon="EditIcon"
                          size="20"
                        />
                      </b-link>
                      <div
                        style="cursor: pointer"
                        @click="renderDeleteConfirmation(data.item)"
                        v-b-modal.modal-delete
                      >
                        <feather-icon
                          class="text-danger"
                          icon="Trash2Icon"
                          size="20"
                        />
                      </div>
                    </div>
                  </template>
                </b-table>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
              >
                <b-pagination
                  v-model="getVipPlansDetails.pageNumber"
                  :total-rows="totalCount"
                  :per-page="getVipPlansDetails.count"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف پلن VIP"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteAVipPlan"
    >
      <b-container>
        <span v-if="tempVipPlan">
          آیا از حذف پلن
          <span style="font-weight: bold !important">
            {{ tempVipPlan.title }}
          </span>
          با مدت زمان
          <span style="font-weight: bold !important">
            {{ tempVipPlan.month }}
          </span>
          ماه اطمینان دارید؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  watch: {
    pageNumber: {
      handler(val) {
        this.getPlansList();
      },
    },
  },
  mounted() {
    this.getPlansList();
  },
  data() {
    return {
      isLoading: false,
      getVipPlansDetails: {
        title: null,
        month: null,
        isActive: null,
        pageNumber: 1,
        count: 10,
      },
      totalCount: null,
      vipPlansList: null,
      tempVipPlan: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "عنوان پلن",
        },
        {
          key: "month",
          label: "مدت زمان پلن",
        },
        {
          key: "hasFridayReserve",
          label: "رزرو جمعه",
        },
        {
          key: "hasMasterReserve",
          label: "رزرو ساعت خاص با اساتید",
        },
        {
          key: "hasMidnightReserve",
          label: "رزرو نیمه شب",
        },
        {
          key: "isActive",
          label: "وضعیت پلن",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      isActiveOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "فعال",
        },
        {
          value: false,
          text: "غیر فعال",
        },
      ],
    };
  },
  methods: {
    setPageNumberAndGetPlansList() {
      this.getVipPlansDetails.pageNumber = 1;
      this.getPlansList();
    },
    renderDeleteConfirmation(vipPlan) {
      this.tempVipPlan = JSON.parse(JSON.stringify(vipPlan));
    },
    async getPlansList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllVipPlans = new GetAllVipPlans(_this);
        getAllVipPlans.setRequestParamDataObj(_this.getVipPlansDetails);
        await getAllVipPlans.fetch((res) => {
          _this.vipPlansList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteAVipPlan() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAVipPlan = new DeleteAVipPlan(_this);
        deleteAVipPlan.setRequestParam({ id: _this.tempVipPlan.id });
        await deleteAVipPlan.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "پلن با موفقیت حذف شد!",
              },
            });
            _this.getPlansList();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.getVipPlansDetails.pageNumber;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
  },
};
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetAllVipPlans, DeleteAVipPlan } from "@/libs/Api/VipUser";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
